(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/validate-voucher.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/validate-voucher.js');
"use strict";


const {
  useState
} = React;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  Form,
  ControlGroup
} = svs.ui.reactForm;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Button = svs.ui.ReactButton;
const {
  LABEL,
  NAME,
  MAX,
  MIN,
  MAX_ERROR_MESSAGE,
  MIN_ERROR_MESSAGE,
  REQUIRED_ERROR_MESSAGE
} = svs.ticket_partner.myOrders.constants.TEXTS.VALIDATE_VOUCHER.VOUCHER_CODE;
const {
  BUTTON_LABEL,
  HEADER
} = svs.ticket_partner.myOrders.constants.TEXTS.VALIDATE_VOUCHER;
const {
  validateCode,
  mapValidateCodeError,
  mapVoucherStatus
} = svs.ticket_partner.myOrders.utils;
const {
  showErrorDialog,
  productMapper
} = svs.ticket_partner.utils;
const ValidateVoucher = () => {
  const [voucherCode, setVoucherCode] = useState('');
  const [voucherData, setVoucherData] = useState(null);
  const handleSubmit = async (e, formData) => {
    e.preventDefault();
    if (_.values(formData).some(_ref => {
      let {
        isValid
      } = _ref;
      return !isValid;
    })) {
      return;
    }
    svs.ui.loader.show();
    try {
      const data = await validateCode(voucherCode);
      setVoucherData(data.response);
    } catch (e) {
      setVoucherData(null);
      const errorMessage = mapValidateCodeError(e);
      showErrorDialog(errorMessage);
    }
    svs.ui.loader.hide();
  };
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-center"
  }, React.createElement("div", {
    style: {
      maxWidth: '600px'
    }
  }, React.createElement("h2", {
    className: ""
  }, HEADER), React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(GridRow, {
    className: ""
  }, React.createElement(GridCol, {
    className: ""
  }, React.createElement(TextInput, {
    errorMessageMax: MAX_ERROR_MESSAGE,
    errorMessageMin: MIN_ERROR_MESSAGE,
    errorMessageRequired: REQUIRED_ERROR_MESSAGE,
    id: NAME,
    isLessSpace: true,
    isRequired: true,
    label: LABEL,
    max: MAX,
    min: MIN,
    name: NAME,
    onChange: e => {
      setVoucherCode(e.target.value);
    },
    value: voucherCode
  }))), voucherData && React.createElement(GridRow, {
    className: "padding-top-2"
  }, React.createElement(GridCol, {
    am: 8,
    className: "",
    sm: 12
  }, React.createElement("div", null, React.createElement("b", null, "Kod: "), React.createElement("span", null, voucherData.voucherInfo[0].voucherId)), React.createElement("div", null, React.createElement("b", null, "Typ: "), React.createElement("span", null, productMapper(voucherData === null || voucherData === void 0 ? void 0 : voucherData.packageId))), React.createElement("div", null, React.createElement("b", null, "Skapad: "), React.createElement("span", null, svs.utils.date.SimpleDate(new Date(voucherData.creationTime)))), React.createElement("div", null, React.createElement("b", null, "Giltig till: "), React.createElement("span", null, svs.utils.date.SimpleDate(new Date(voucherData.lastValidDate)))), React.createElement("div", null, React.createElement("b", null, "Status: "), React.createElement("span", null, mapVoucherStatus(voucherData))))), React.createElement(GridCol, null, React.createElement(GridRow, null, React.createElement(ControlGroup, {
    className: "",
    v2: true
  }, React.createElement(Button, {
    className: "u-flex u-flex-align-items-center button-row-button-center u-flex-justify-content-center",
    transparent: true,
    type: "submit"
  }, BUTTON_LABEL)))))));
};
svs.ticket_partner.myOrders.components.ValidateVoucher = ValidateVoucher;

 })(window);